<script lang="ts">
	import { Button, ButtonType, ButtonSize } from '@repo/commons/components'
	import { t } from 'svelte-i18n'

	interface Props {
		positiveButtonText?: string
		negativeButtonText?: string
		onButtonClick: (isConfirmed: boolean) => void
		isButtonLoading?: boolean
		submitButtonOnTheLeft?: boolean
	}

	let {
		positiveButtonText = $t('Submit'),
		negativeButtonText = $t('Cancel'),
		onButtonClick,
		isButtonLoading = $bindable(false),
		submitButtonOnTheLeft = true
	}: Props = $props()
</script>

<div class="confirmation-buttons {submitButtonOnTheLeft ? '' : 'reverse'}">
	<Button
		buttonText={positiveButtonText}
		buttonType={ButtonType.BRAND}
		buttonSize={ButtonSize.MEDIUM}
		onclick={() => onButtonClick(true)}
	/>
	<Button
		buttonText={negativeButtonText}
		buttonType={ButtonType.DESTRUCTIVE}
		buttonSize={ButtonSize.MEDIUM}
		onclick={() => onButtonClick(false)}
		isLoading={isButtonLoading}
	/>
</div>

<style>
	.confirmation-buttons {
		@apply flex justify-end gap-2;
	}
	.confirmation-buttons.reverse {
		@apply flex-row-reverse;
	}
</style>
